/**
 * Localization convention for wizard flow config JSON.
 *
 * Any node that carries translatable strings can include an optional `_i18n`
 * sibling object keyed by language code. Each language entry is a flat map
 * from field name -> translated value.
 *
 * Example:
 *   {
 *     "title": "My Info",
 *     "_i18n": { "es": { "title": "Mi informacion" } }
 *   }
 *
 * Empty/undefined/null localized values fall back to the base field so a
 * partially-translated config behaves consistently.
 */
export interface Localizable {
  _i18n?: Record<string, Record<string, string>>;
}

export function localizeField<T extends Localizable, K extends keyof T & string>(
  node: T | undefined | null,
  field: K,
  lang: string | undefined | null,
): T[K] | undefined {
  if (!node) {
    return undefined;
  }
  if (lang) {
    const localized = node._i18n?.[lang]?.[field];
    if (localized !== undefined && localized !== null && localized !== '') {
      return localized as unknown as T[K];
    }
  }
  return node[field];
}
